import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FormGroupMaterial } from '../externaljs/FormGroupMaterial';
import Urls from '../externaljs/Urls';
import GetData from '../services/GetData';
import PostDataWithParam from '../services/PostDataWithParam';

class SignUp extends Component {
    state = {
        fields: {
            contact_no: '',
            email: '',
            organization_name: '',
            password: '',
            profile_id: 14,
            card_name: '',
            card_no: '',
            expiry_month: '',
            expiry_year: '',
            cvv_no: '',
            amount: '',
            company_contact_no: '',
            first_name: '',
            last_name: '',
            subscription_id: 13,
            website_link: '',
            position: '',
            confirm_password: '',
            associated_with_id: '',
            movers_organization_name: '',
            movers_email: '',
            city: '',
            state: '',
            zip: '',
            country: '',  //new added
            address: '',
            support_email: 'help@myrelo.us',
            url: 'myrelopro.com/claimrepair-home'
        },
        error: {
            confPasswordErr: '',
            dobErr: ''
        },
        processing: false,
        regStatus: false,
        moving_company_form: false,
        moving_company_select: true,
        regErr: '',
        allStates: [],
        allCountries: [],
        primaryCities: [],
        select_address: true,
        google_map: '',
    }



    initMultiSelect = () => {
        window.$('.select-search').select2({
            placeholder: "Select/Add a Claim Repair Company ",
            ajax: {
                url: Urls.api + 'GetMoversListForRegistration',
                dataType: 'json',
                processResults: (data) => {
                    // Tranforms the top-level key of the response object from 'items' to 'results'
                    let term = window.$('.select2-search__field')[0].value;

                    if (data.success == 0 && term != "") {
                        let fields = this.state.fields;
                        fields.associated_with_id = '';
                        fields.movers_organization_name = term;
                        this.setState({ moving_company_form: true, fields: fields }, () => {
                            // window.$("#select_associated_with_id").val('').trigger('change');
                        });
                    }
                    if (data.success == 1) {
                        this.setState({ moving_company_form: false });
                    }
                    return {
                        results: data.result
                    };
                }
            }
        })
            .off('select2:select')
            .on('select2:select', e => {
                let selname = e.target.name;
                let fields = this.state.fields;
                fields.associated_with_id = e.target.value;
                this.setState({ fields: fields });
            }).on('select2:close', (e) => {
                if (this.state.fields.movers_organization_name != "" && this.state.moving_company_form)
                    this.setState(() => ({ moving_company_select: false }))
            })
    }

    componentDidMount() {
        this.initMultiSelect();
        FormGroupMaterial();
        this.getCountries();
        this.getStates();
        const searchParams = new URLSearchParams(this.props.location.search);
        let referral_code = "";
        if (!!searchParams.get("rc")) {
            referral_code = searchParams.get("rc");
        }
        this.setState({
            fields: {
                ...this.state.fields,
                referral_code
            }
        })

        if (this.props.location.state && typeof this.props.location.state.amount != 'undefined' && typeof this.props.location.state.subscription_id != 'undefined') {
            if (typeof this.props.location.state.email == 'undefined') {
                let fields = Object.assign({}, this.state.fields);
                fields.amount = this.props.location.state.amount;
                fields.subscription_id = this.props.location.state.subscription_id;

                this.setState({ fields: fields }, () => {

                })
            } else {
                this.setState({ fields: this.props.location.state }, () => {
                });
            }
        }
        this.setState({ regErr: '' });
    }


    changeValue = (e) => {
        let fields = this.state.fields;
        if (e.target.name == 'movers_organization_name') {
            this.setState({ moving_company_select: false });
        }
        fields[e.target.name] = e.target.value;
        if (e.target.name == 'contact_no' || e.target.name == 'company_contact_no') {
            var cleaned = ('' + e.target.value).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                fields[e.target.name] = match[1] + ' ' + match[2] + ' ' + match[3]
            }
            else {
                fields[e.target.name] = cleaned;
            }
        }
        this.setState({ fields: fields });
    }

    handleAddMmc = (e) => {
        e.preventDefault();
        let error = this.state.error;
        if (this.state.fields.password !== this.state.fields.confirm_password) {
            error.confPasswordErr = 'Password & Confirm password does not match.';
            this.setState({ error: error });
        } else {
            error.confPasswordErr = '';
            this.setState({ error: error });
            if (this.state.fields.subscription_id == 13) {
                this.setState({ processing: true }, () => {
                    PostDataWithParam('UserRegistration', this.state.fields)
                        .then((response) => {
                            if (response.success == 1) {
                                this.setState({ regErr: response.msg, regStatus: true });
                            } else {
                                this.setState({ regErr: response.msg, processing: false, regStatus: false });
                            }
                        })
                        .catch(err => {
                            this.setState({ regErr: 'Oops! Something went wrong.', processing: false, regStatus: false });
                        })
                })
            } else {
                this.setState({ processing: true }, () => {
                    PostDataWithParam('DuplicateEmailCheck', { email_id: this.state.fields.email })
                        .then((response) => {
                            if (response.success == 1) {
                                this.setState({ processing: false }, () => {
                                    this.props.history.push({
                                        pathname: '/registration-claimrepair-step-two',
                                        state: this.state.fields
                                    })
                                });
                            } else {
                                this.setState({ regErr: response.msg, processing: false, regStatus: false });
                            }
                        })
                        .catch(err => {
                            this.setState({ regErr: 'Oops! Something went wrong.', processing: false, regStatus: false });
                        })
                });
            }
        }
    }

    renderSubmitBtn = () => {
        if (this.state.processing) {
            return <input type="button" className="btn btn-primary" value="Processing..." disabled={true} />
        } else {
            if (this.state.fields.subscription_id == 13)
                return <button type="submit" className="btn btn-primary">REGISTER</button>
            else
                return <button type="submit" className="btn btn-primary">CONTINUE</button>
        }
    }

    showAlert = (status) => {
        if (status != '') {
            return (
                <div className="alert alert-danger no-border"><button type="button" className="close" data-dismiss="alert"><span>×</span><span className="sr-only">Close</span></button>
                    {this.state.regErr}
                </div>
            )
        }
    }

    initAutocomplete = (e) => {
        let addressName = e.target.name;
        let fields = this.state.fields;
        fields.address = e.target.value;
        this.setState({ fields: fields });

        var componentForm = {
            country: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            postal_code: 'short_name'
        };

        if (addressName == "address") {
            fields.city = '';
            fields.state = '';
            fields.zip = '';
            fields.country = '';
        }

        let autocomplete = new window.google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */(document.getElementById(e.target.id)),
            { types: [] });

        window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
            let place = autocomplete.getPlace();
            let fields = this.state.fields;

            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (componentForm[addressType]) {
                    var val = place.address_components[i][componentForm[addressType]];
                    if (addressType == "administrative_area_level_1")
                        fields.state = val
                    else if (addressType == "locality")
                        fields.city = val
                    else if (addressType == "postal_code")
                        fields.zip = val
                    else
                        fields.country = val
                }
            }

            let address = '';
            let flag = 0;
            if (addressName == "address") {
                for (let i = 0; i < place.address_components.length; i++) {
                    if (place.address_components[i].types[0] == "street_number" || place.address_components[i].types[0] == "route" || place.address_components[i].types[0] == "sublocality_level_1" || place.address_components[i].types[0] == "sublocality_level_2" || place.address_components[i].types[0] == "sublocality_level_3") {
                        address = address + " " + place.address_components[i].long_name
                        flag = 1;
                    }
                    if (flag != 1) {

                        if (place.address_components[i].types[0] == "locality") {

                            address = address + " " + place.address_components[i].long_name;
                            flag = 0;
                        }
                    }
                }
                fields.address = address;
            }

            // fields.address = place.formatted_address;
            this.setState({ fields: fields }, () => {
            });
        })
    }

    // initAutocomplete = (e) => {
    //     let fields = this.state.fields;
    //     fields.address = e.target.value;
    //     this.setState({ fields: fields });

    //     var componentForm = {
    //         country: 'long_name',
    //         locality: 'long_name',
    //         administrative_area_level_1: 'short_name',
    //         postal_code: 'short_name'
    //     };

    //     let autocomplete = new window.google.maps.places.Autocomplete(
    //         /** @type {!HTMLInputElement} */(document.getElementById(e.target.id)),
    //         { types: [] });

    //     window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
    //         let place = autocomplete.getPlace();
    //         let fields = this.state.fields;

    //         for (var i = 0; i < place.address_components.length; i++) {
    //             var addressType = place.address_components[i].types[0];
    //             if (componentForm[addressType]) {
    //                 var val = place.address_components[i][componentForm[addressType]];
    //                 if (addressType == "administrative_area_level_1")
    //                     fields.state = val
    //                 else if (addressType == "locality")
    //                     fields.city = val
    //                 else if (addressType == "postal_code")
    //                     fields.zip = val
    //             }
    //         }

    //         fields.address = place.formatted_address;
    //         this.setState({ fields: fields }, () => {
    //         });
    //     })
    // }

    getCountries() {
        GetData('CountryList', {})
            .then((response) => {
                let result = response;
                if (result.success === 1) {
                    this.setState({ allCountries: result.data });
                } else {
                    this.setState({ UpdateErr: result.msg });
                }

            })
            .catch(err => {

            })
    }

    getStates() {

        PostDataWithParam('GetStates', {})
            .then((response) => {
                let result = response;
                if (result.success === 1) {
                    this.setState({ allStates: result.data });
                } else {
                    this.setState({ UpdateErr: result.msg });
                }
            })
            .catch(err => {

            })
    }

    render() {

        const { allCountries } = this.state;
        const { allStates } = this.state;
        let countriesList = allCountries.length > 0
            && allCountries.map((item, i) => {
                return (
                    <option key={i} value={item.country_name}>{item.country_name}</option>
                )
            }, this);

        let stateList = allStates.length > 0
            && allStates.map((item, i) => {
                return (
                    <option key={i} value={item.state_code}>{item.state}</option>
                )
            }, this);

        if (this.state.regStatus) {
            return <Redirect to={{
                pathname: '/login',
                state: { regErr: this.state.regErr }
            }} />
        }

        return (
            <section className="login-register-bg">
                <div className="login-register-box">
                    <div className="login-register-header-box text-center">
                        <div className="m-b-40">
                            <a href="http://myrelopro.com/" className="logo"><img src="assets/images/MyReloPro-logo-black.png" alt="" /></a>
                        </div>
                        <div className="btn-group">
                            <Link to="/login" className="btn border-slate text-slate-800 btn-flat text-uppercase">Sign in</Link>
                            <Link to={{
                                pathname: '/registration-claimrepair',
                                state: { subscription_id: 13, amount: 0 }
                            }} className="btn border-slate text-slate-800 btn-flat text-uppercase active">Create Free Account
                            <p className="m-0 f-s-13">(No Credit Card Required)</p>
                            </Link>
                        </div>
                        <br />

                    </div>
                    <form action="#" method="POST" onSubmit={this.handleAddMmc}>
                        <div className="login-box-body m-t-30">
                            {this.showAlert(this.state.regErr)}
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">First Name<span className="text-danger m-l-5">*</span></label>
                                        <input type="text" name="first_name" value={this.state.fields.first_name} className="form-control" placeholder="First Name" onChange={this.changeValue} required />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">Last Name<span className="text-danger m-l-5">*</span></label>
                                        <input type="text" name="last_name" value={this.state.fields.last_name} className="form-control" placeholder="Last Name" onChange={this.changeValue} required />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">Email Address<span className="text-danger m-l-5">*</span></label>
                                        <input type="email" name="email" value={this.state.fields.email} className="form-control" placeholder="Email" onChange={this.changeValue} required />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">Mobile Phone Number<span className="text-danger m-l-5">*</span></label>
                                        <input type="text" name="contact_no" value={this.state.fields.contact_no} className="form-control" onChange={this.changeValue} maxLength="12" required placeholder="Mobile Phone Number" />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                {
                                    this.state.moving_company_select
                                    &&
                                    <div className="col-md-12">
                                        <div className="form-group form-group-material">
                                            <label className="control-label animate">Your Moving Company<span className="text-danger m-l-5"></span></label>
                                            <select name="associated_with_id" id="select_associated_with_id" className="select-search form-control" value={this.state.fields.associated_with_id} onChange={this.changeValue}>
                                            </select>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.moving_company_form
                                    &&
                                    <div>
                                        <div className="col-md-12">
                                            <div className="form-group form-group-material">
                                                <label className="control-label animate">Company Name<span className="text-danger m-l-5">*</span></label>
                                                <input type="text" name="movers_organization_name" value={this.state.fields.movers_organization_name} className="form-control" placeholder="Company Name" onChange={this.changeValue} required />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group form-group-material">
                                                    <label className="control-label animate">Company Email<span className="text-danger m-l-5">*</span></label>
                                                    <input type="email" name="movers_email" value={this.state.fields.movers_email} className="form-control" placeholder="Company Email" onChange={this.changeValue} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group form-group-material">
                                                    <label className="control-label animate">Company Phone Number<span className="text-danger m-l-5">*</span></label>
                                                    <input type="text" name="company_contact_no" value={this.state.fields.company_contact_no} className="form-control" placeholder="Company Main Telephone No." maxLength="12" onChange={this.changeValue} required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group form-group-material">
                                                <label className="control-label animate">Company Address</label>
                                                <input type="text" name="address" id="address" value={this.state.fields.address} className="form-control" placeholder="Company Address" onChange={this.initAutocomplete} />
                                            </div>
                                            {/* Address Sub-fields added */}
                                            <div className="row" >

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        {/* <label className="control-label animate">City</label> */}
                                                        <input type="text" className="form-control" id="city" name="city" value={this.state.fields.city} placeholder='City' onChange={this.changeValue}></input>
                                                        {/* readOnly={this.state.primary_pickup_address_check} */}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        {/* <label className="control-label animate">State</label> */}
                                                        {/* <input type="text" className="form-control" id="state" name="state" value={this.state.fields.state || ''} placeholder='State' onChange={this.changeValue}></input> */}
                                                        {/* readOnly={this.state.primary_pickup_address_check} */}
                                                        <select className="form-control" id="state"
                                                            value={this.state.fields.state}
                                                            name="state" placeholder='State' onChange={this.changeValue}>
                                                            {stateList}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        {/* <label className="control-label animate">Zip</label> */}
                                                        <input type="text" className="form-control" id="zip" name="zip" value={this.state.fields.zip || ''} placeholder='Zip' onChange={this.changeValue}></input>
                                                        {/* readOnly={this.state.primary_pickup_address_check} */}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        {/* <label className="control-label animate">Country</label> */}
                                                        <select className="form-control" id="country"
                                                            value={this.state.fields.country}
                                                            name="country" placeholder='Country' onChange={this.changeValue}>
                                                            {countriesList}
                                                        </select>

                                                    </div>
                                                </div>
                                                {/* <input type="text" className="form-control" id="primary_pickup_country" name="primary_pickup_country" value={this.state.form_data.primary_pickup_country} placeholder='' onChange={this.changeValue}></input> */}
                                                {/* readOnly={this.state.primary_pickup_address_check} */}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">Password<span className="text-danger m-l-5">*</span></label>
                                        <input type="password" name="password" value={this.state.fields.password} className="form-control" placeholder="Password" onChange={this.changeValue} required />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group form-group-material">
                                        <label className="control-label animate">Password Confirmation<span className="text-danger m-l-5">*</span></label>
                                        <input type="password" name="confirm_password" value={this.state.fields.confirm_password} className="form-control" placeholder="Confirm Password" onChange={this.changeValue} required />
                                        <p className="text-danger help-block">{this.state.error.confPasswordErr}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group m-t-20 m-b-10 clearfix text-center">
                                {this.renderSubmitBtn()}
                            </div>
                            <p className="text-center text-grey-400 f-s-12">By clicking <strong>REGISTER</strong> you agree to our <Link to="/terms-service" target="_blank" className="text-underline f-s-15">terms and conditions</Link></p>
                        </div>
                        <hr className="m-b-20" />
                        <div className="login-box-footer text-center">
                            <span className="text-grey-400"> Already have an account?</span>
                            <Link to="/login" className="link-btn">Sign In</Link>
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}

export default SignUp;